import React, {useEffect} from 'react';
import { Button, Modal, Title } from '@gjensidige/builders-components';
import { IPricingQuestion } from '../../interfaces/EnquiryInterface';
import { Enquiry } from '../Enquiry/Enquiry';

interface AddInputsModalProps {
  isOpen: boolean;
  additionalModalInputs: IPricingQuestion[];
  modalHeader: string;
  criticalButtonLabel: string;
  primaryButonLabel: string;
  closeBtnLabel?: string;
  modalLabel?: string;
  onModalClose: () => void;
  onInputChange: (type: string, value: string, isValid?: boolean) => void;
  criticalButtonAction: () => void;
  primaryButtonAction: () => void;
}
export const AddInputsModal: React.FC<AddInputsModalProps> = (
  props: AddInputsModalProps
) => {
  const isCriticalButtonDisabled = props.additionalModalInputs.some(
    (item: IPricingQuestion) => item.selectedValue === '' || !item.isValid
  );
  return (
    <Modal
      aria-label={props.modalLabel || 'add-input-content-area'}
      className="additional-input-modal"
      open={props.isOpen}
      //strict={true}
      onClose={props.onModalClose}
      closeLabel={props.closeBtnLabel || 'Avbryt att lägga till byggnad'}
    >
      <div className="add-input-modal-content">
        <div className="modal-header">
          <Title as="h2" size="5" tabIndex={-1}>{props.modalHeader}</Title>
        </div>
        <div className="modal-inputs-wrapper">
          {props.additionalModalInputs.map(
            (item: IPricingQuestion, index: number) => {
              return (
                item.isVisible && (
                  <div key={index}>
                    <Enquiry
                      data={item}
                      handleChange={props.onInputChange}
                      alignCenter={false}
                      isVertical={false}
                      stepCode="001"
                      mainHeader={false}
                    />
                  </div>
                )
              );
            }
          )}
        </div>
        <div className="modal-footer-wrapper mt-1">
          <Button
            fill
            onClick={props.criticalButtonAction}
            tracking={false}
            color="blue"
            className="next-radio-button critical-button-padding footer-sm-device my-2"
            size="md"
            variant="primary"
            disabled={isCriticalButtonDisabled}
          >
            {props.criticalButtonLabel}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
